<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <h1>Сессии</h1>
      <v-data-table
              no-data-text="Нет тегов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="sessions"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              loading-text="Загрузка тегов... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ProductService from './../../api/ProductService'
    import CategoryService from './../../api/CategoryService'
    import TagService from './../../api/TagService'
    import SessionService from "@/api/SessionService";

    export default {
        name: 'TagIndex',
        components: {},
        data: () => ({
            snackbar: false,
            timeout: 2000,
            snackbarText: '',
            snackbarColor: '',
            valid: false,
            submitDialog: false,
            submitItem: null,
            overlay: false,
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            sessions: [],
            options: {},
            image: null,
            imageUa: null,
            tag: {
                id: null,
                name: '',
                name_ua: '',
                image: ''
            },
            rules: {
              required: value => !!value || 'Нужно заполнить',
              requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
            },
            footerProps: {
                itemsPerPageText: 'Тегов на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            headers: [
                {
                    text: 'Сессия',
                    value: 'token',
                    sortable: false
                },
                {
                    text: 'Юзер',
                    value: 'email',
                    sortable: false
                },
                {
                    text: 'Заканчивается',
                    value: 'expired_at',
                    sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          setImage(){
            if(this.tag.image){
              this.image = this.tag.image;
              this.image.name = this.tag.image.file
            } else {
              this.image = null
            }

            if(this.tag.image_ua){
              this.imageUa = this.tag.image_ua;
              this.imageUa.name = this.tag.image_ua.file
            } else {
              this.imageUa = null
            }
          },
          previewImage(tagImage) {
            if(this.image && this.image.url){
              return this.image.url
            }
            if(tagImage){
              return URL.createObjectURL(tagImage)
            }
            return null;

          },
          previewImageUa(tagImage) {
            if(this.imageUa && this.imageUa.url){
              return this.imageUa.url
            }
            if(tagImage){
              return URL.createObjectURL(tagImage)
            }
            return null;

          },
          submitDelete(item = null){
            if(item){
              this.removeTag(item)
            } else {
              // this.massDelete()
            }
          },
            validate(){
              this.$refs.tabForm.validate()
              if(this.tag.name == '' && this.tag.name_ua != ''){
                this.tab = 0;
              }
              if(this.tag.name != '' && this.tag.name_ua == ''){
                this.tab = 1;
              }
            },
            removeTag(item){
              SessionService.remove(item.session_id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            getData(){
              let formData = new FormData();

              formData.append('name_ua', this.tag.name_ua);
              formData.append('name', this.tag.name);
              if(this.tag.id){
                formData.append('id', this.tag.id);
              }
              if(this.image && !this.image.url) {
                formData.append('image', this.image);
              }
              if(this.imageUa && !this.imageUa.url) {
                formData.append('imageUa', this.imageUa);
              }
              return formData
            },
            createTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
              let data = this.getData();
                this.loadingModal = true;
                TagService.create(data).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                    this.snackbarText = 'Тег создан';
                    this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при создании тега';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            updateTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
              let data = this.getData();
                this.loadingModal = true;
                TagService.update(data).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                  this.snackbarText = 'Тег обновлен';
                  this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при обновлении тега';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                SessionService.list({})
                    .then(response => {
                        this.sessions = response.data.map(item => ({...item, token: item.token.slice(0, 5) + '...' + item.token.slice(-5)}))
                        this.loading = false
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
